import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { hasSizes } from "../../utils/product/hasSizes";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";
import { removeIFCMessages } from "../../utils/product/interestFreeCredit/removeIFCMessages";
import { FeatureMessagesDrawerUI } from "./FeatureMessagesDrawerUI";

export function FeatureMessagesDrawer({
  product,
}: Pick<StandardProps, "product">) {
  const router = useRouter();
  const sizeParam = getSizeQuery(router.query);
  const { variant } = useVariant(product);
  const productHasSizes = hasSizes(product);
  const isVariantExplicitlySelected = productHasSizes && sizeParam;

  const messages =
    (isVariantExplicitlySelected ? variant.messaging : product.messaging) || [];

  const cleanedMessages = removeIFCMessages(messages);

  return <FeatureMessagesDrawerUI messages={cleanedMessages} />;
}
